import {
	Input as CoreInput,
	Select as CoreSelect
} from "@sparefoot/react-commons";

import { withFormField } from "./withFormField";

const FIELD_TYPES = {
	email: "email",
	phone: "tel",
	text: "text"
};

export const TextField = withFormField(CoreInput, FIELD_TYPES.text);
export const EmailField = withFormField(CoreInput, FIELD_TYPES.email);
export const PhoneField = withFormField(CoreInput, FIELD_TYPES.phone);
export const SelectField = withFormField(CoreSelect);
